// root/frontend/src/Modal/PrivacyPolicyModal.jsx
import React from "react";
import styles from "./ModalContent.module.css";

export const PrivacyPolicyModal = () => {
  return (
    <div className={styles.modalBody}>
      <div className={styles.modalHeader}>
        <h2>Privacy Policy for Jigyasa AI</h2>
        <p className={styles.lastUpdated}>
          <em>Last updated: 30th August 2025</em>
        </p>
      </div>

      <div className={styles.modalContent}>
        <div className={styles.tabContent}>
          <div className={styles.section}>
            <p>
              Jigyasa AI ("we", "our", "us") respects your privacy. This Privacy
              Policy explains how we collect, use, and protect your information
              when you use our platform.
            </p>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>1. Information We Collect</h3>
            <p>
              When you use Jigyasa AI, we may collect the following information:
            </p>
            <ul className={styles.stepList}>
              <li>
                <strong>Email address</strong> (through Google Sign-In).
              </li>
              <li>
                <strong>User answers</strong> to comprehension questions.
              </li>
              <li>
                <strong>Automatically collected data:</strong> Currently, we do
                not collect device details, cookies, or tracking data. In the
                future, we may use analytics tools (e.g., Google Analytics) to
                improve our services.
              </li>
            </ul>
            <p>
              We do <strong>not</strong> store passwords.
            </p>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>
              2. How We Use Your Information
            </h3>
            <p>We use the collected information to:</p>
            <ul className={styles.stepList}>
              <li>Provide access to our platform and features.</li>
              <li>Save and display your answers.</li>
              <li>
                Improve our comprehensions, questions, and learning experience.
              </li>
              <li>
                Communicate with you about updates or changes to our platform.
              </li>
            </ul>
            <p>
              We do <strong>not</strong> sell, rent, or share your personal data
              with third parties.
            </p>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>3. Data Retention</h3>
            <ul className={styles.stepList}>
              <li>
                User answers and associated email IDs may be stored for a long
                period.
              </li>
              <li>
                If you would like your data to be deleted, you can contact us at{" "}
                <strong>jigyasa.ai.hindi@gmail.com</strong>.
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>4. Children's Privacy</h3>
            <p>
              Our platform may be used by children as young as 9 years old
              (e.g., Class 3 students).
            </p>
            <ul className={styles.stepList}>
              <li>
                We recommend that parents, guardians, teachers or schools
                supervise children's use of Jigyasa AI.
              </li>
              <li>
                We do not knowingly collect more personal information than
                necessary from children.
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>5. Data Security</h3>
            <p>
              We take reasonable steps to protect your information from
              unauthorized access, alteration, or disclosure. However, no method
              of online storage is 100% secure.
            </p>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>6. Use of Google APIs</h3>
            <p>Jigyasa AI uses Google APIs for:</p>
            <ul className={styles.stepList}>
              <li>
                <strong>Login</strong> (Google Sign-In).
              </li>
              <li>
                <strong>Question answering support</strong>.
              </li>
            </ul>
            <p>
              By using our platform, you agree to the Google Privacy Policy.
            </p>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>7. Future Changes</h3>
            <ul className={styles.stepList}>
              <li>
                If we introduce analytics, tracking tools, or monetization
                features, we will update this policy.
              </li>
              <li>
                We encourage you to review this policy from time to time for the
                latest information.
              </li>
            </ul>
          </div>

          <div className={styles.section}>
            <h3 className={styles.sectionTitle}>8. Contact Us</h3>
            <p>
              If you have questions about this Privacy Policy or wish to request
              data deletion, please contact us at:
            </p>
            <div className={styles.contactInfo}>
              <p>
                <strong>📧 jigyasa.ai.hindi@gmail.com</strong>
              </p>
            </div>
          </div>

          <div className={styles.helpSection}>
            <h4>Questions about Privacy?</h4>
            <p>
              Contact us anytime at jigyasa.ai.hindi@gmail.com for
              privacy-related concerns.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
